import '../styles/cookieconsent.scss'
import './vendor/cookieconsent.js'

(function(occ) {
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  // stop from running again, if accidently included more than once.
  if (occ.hasInitialized) return;

  occ.init = function(options) {
    if (typeof options.enableCookies === "function") {
      occ.enableCookies = options.enableCookies;
    }
    if (typeof options.disableCookies === "function") {
      occ.disableCookies = options.disableCookies;
    }

    const cookieConsentSettings = options.cookieconsent || {};

    const countryOverride = getUrlParameter('cookieconsentcountry');
    if (countryOverride.length) {
      cookieConsentSettings.law.countryCode = countryOverride;
    }

    function handleEnableDisable(status, type, didConsent) {
      if (type == 'info') {
        return occ.enableCookies();
      }
      if (type == 'opt-out' && status != "deny") {
        return occ.enableCookies();
      }
      if (type == 'opt-in' && status == "allow") {
        return occ.enableCookies();
      }
      if (!didConsent || status == "deny") {
        return occ.disableCookies();
      }
    }

    cookieConsentSettings.onInitialise = function(status) {
      const type = this.options.type;
      const didConsent = this.hasConsented();
      return handleEnableDisable(status, type, didConsent);
    };

    cookieConsentSettings.onStatusChange = function(status, chosenBefore) {
      const type = this.options.type;
      const didConsent = this.hasConsented();
      return handleEnableDisable(status, type, didConsent);
    };

    cookieConsentSettings.onRevokeChoice = function() {
      occ.disableCookies();
    };

    window.cookieconsent.initialise(cookieConsentSettings);
  }

  // prevent this code from being run twice
  occ.hasInitialized = true;

  window.onecookieconsent = occ;
}(window.onecookieconsent || {}));
